import script from "./ElencoContatti.vue?vue&type=script&setup=true&lang=js"
export * from "./ElencoContatti.vue?vue&type=script&setup=true&lang=js"

import "./ElencoContatti.vue?vue&type=style&index=0&id=01eecd6e&lang=css"

const __exports__ = script;

export default __exports__